import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const LockIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
            <path
                d="M14.9999 6.66668H14.1666V5.00001C14.1666 2.70001 12.2999 0.833344 9.99992 0.833344C7.69992 0.833344 5.83325 2.70001 5.83325 5.00001V6.66668H4.99992C4.08325 6.66668 3.33325 7.41668 3.33325 8.33334V16.6667C3.33325 17.5833 4.08325 18.3333 4.99992 18.3333H14.9999C15.9166 18.3333 16.6666 17.5833 16.6666 16.6667V8.33334C16.6666 7.41668 15.9166 6.66668 14.9999 6.66668ZM9.99992 14.1667C9.08325 14.1667 8.33325 13.4167 8.33325 12.5C8.33325 11.5833 9.08325 10.8333 9.99992 10.8333C10.9166 10.8333 11.6666 11.5833 11.6666 12.5C11.6666 13.4167 10.9166 14.1667 9.99992 14.1667ZM12.5833 6.66668H7.41658V5.00001C7.41658 3.57501 8.57492 2.41668 9.99992 2.41668C11.4249 2.41668 12.5833 3.57501 12.5833 5.00001V6.66668Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};
